import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation, Trans } from 'react-i18next'
import {
  SmallText,
  TextLink,
} from 'ggx-componentlibrary/design/typography/typography.styles'

import { OrderChargeMessage, ErrorMessage } from './wallet.component.styles'

const Wallet = ({
  orderQuotation,
  prepaidBalance,
  input,
  meta,
  hideDisclaimers,
}) => {
  const [t] = useTranslation()
  const sufficientBalance =
    prepaidBalance > 0 && prepaidBalance >= orderQuotation

  useEffect(() => {
    input.onChange(sufficientBalance)
  }, [sufficientBalance])

  const { touched, error } = meta
  const errorMessage = touched || orderQuotation > prepaidBalance ? error : null

  return (
    <React.Fragment>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

      {!hideDisclaimers && (
        <SmallText typographyStyles="mt-m mb-none">
          <Trans
            i18nKey="common__text_terms&conditions"
            components={
              <TextLink
                href={t('common__link_terms&conditions')}
                target="_blank"
              />
            }
          />
        </SmallText>
      )}
    </React.Fragment>
  )
}

Wallet.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  orderQuotation: PropTypes.number,
  prepaidBalance: PropTypes.number,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }),
  hideDisclaimers: PropTypes.bool,
}

Wallet.defaultProps = {}

export { Wallet }
